export default __webpack_public_path__ + "static/media/12.0ad28a5b.jpg";